import { Summary } from "lib/service/client/FrontTopPageService";
import React, { FC, HTMLAttributes, useMemo } from "react";
import SsHeadline from "../layout/SsHeadline";
import Link from "next/link";
import styled from "styled-components";
import { TopPageProject } from "interfaces/front/page/top";
import ProjectCard from "./ProjectCard";

export type Props = HTMLAttributes<HTMLElement> & {
  projects: TopPageProject[];
  summaries?: Summary[];
};
const HometownTaxProjectSection: FC<Props> = ({ projects, summaries, ...props }) => {
  const projectSummaryPairs = useMemo(() => {
    return projects.map((project) => {
      const summary = summaries?.find((summary) => summary.project_id === Number(project.id));
      return { project, summary };
    });
  }, [projects, summaries]);
  return (
    <section {...props}>
      <SsHeadline color="white" label={<Logo src="img/hometown_tax_logo.png" />} />
      <CardList>
        {projectSummaryPairs.map((pair, index) => (
          <ProjectCard key={index} project={pair.project} summary={pair.summary} />
        ))}
      </CardList>
      <BannerArea>
        <Link href="/lp/animefurusato">
          <BannerImage src="/image/banner/animefurusato/lp.png" alt="アニメふるさと納税とは" loading="lazy" />
        </Link>
        <Link href="/animefurusato/simulator">
          <BannerImage src="/image/banner/animefurusato/simulator.png" alt="寄附限度額をチェック" loading="lazy" />
        </Link>
      </BannerArea>
    </section>
  );
};
export default HometownTaxProjectSection;

const Logo = styled.img`
  @media screen and (max-width: 960px) {
    height: 21px;
  }
  @media screen and (min-width: 961px) {
    height: 36px;
  }
`;
const BannerArea = styled.div`
  margin: 20px 20px 0;
  display: flex;
  @media screen and (max-width: 960px) {
    justify-content: center;
    flex-wrap: wrap;
  }
  @media screen and (min-width: 961px) {
    justify-content: center;
  }
`;
const BannerImage = styled.img`
  cursor: pointer;
  margin-right: 10px;
  margin-left: 10px;
  @media screen and (max-width: 960px) {
    margin-bottom: 10px;
    width: 300px;
  }
  @media screen and (min-width: 961px) {
    width: 400px;
  }
`;
const CardList = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media screen and (min-width: 961px) {
    &:after {
      content: "";
      display: block;
      width: calc((100% - 30px) / 3);
    }
  }
`;
